import React, { useEffect, useMemo } from "react";
import { Transformador } from "..";
import { SimpleSelectOqt, TextOqt, WrapperComponent, useDialogNodeContext } from "../..";
import { useFlowContext } from "../../../contexts/Flow";
import { isNode } from "react-flow-renderer";
import { getTargetsNodes } from "../HelperFunctions";

const clipboardFields = ["etiqueta", "tipoConexion", "condicion"];

export const FormEdgeEdit = ({fmk, formData}) => {

  const { clipboard } = useDialogNodeContext();
  const { flowData } = useFlowContext();

  useEffect(()=>{
    clipboard.setCopyProps(clipboardFields);
    clipboard.setPasteProps(clipboardFields);
  }, [])

  const elements = useMemo(()=>{
    const flow = flowData.get();
    const id = fmk.values.id;
    const targets = getTargetsNodes(id, flow).map(element => element.id);
    return flow
      .sort(function (a, b){
        return a.data.nombre < b.data.nombre ? -1 : ( a.data.nombre > b.data.nombre ? 1 : 0);
      })
      .filter(element => isNode(element) && element.type !== "NodeStart")
      .map(element => ({value: element.id, label: `${element.data.nombre}`, isDisabled: targets.some(id => id === element.id)}))
  }, []);

  useEffect(()=>{
    if(fmk.values.tipoConexion){
      fmk.setFieldValue("color", formData.tiposConexiones.find(x => x.value === fmk.values.tipoConexion)?.color)
    }
  }, [fmk.values])

  return (
    <>
      <WrapperComponent caption="Etiqueta" Field={<TextOqt autoFocus name="etiqueta" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Tipo de conexión" Field={<SimpleSelectOqt name="tipoConexion" formik={fmk} variant="standard" optionsList={formData.tiposConexiones}/>}/>
      {fmk.values && (fmk.values.tipoConexion === "CONDICIONAL" || fmk.values.tipoConexion === "ERROR") &&
        <WrapperComponent caption="Condición" Field={
          <Transformador caption="Edición de condición" formik={fmk} name="condicion" tiposTransformaciones={[{label: "Fórmula", value: 'FORMULA'}]}/>
        }/>      
      }
      <WrapperComponent caption="Nodo de salida" Field={<SimpleSelectOqt name="salida" formik={fmk} variant="standard" options="elements" data={{elements}}/>}/>
    </>
  )
}